/**
 * section-slider-init.js
 *
 * Shared initializer for the SXSlider carousel used by product-grid sections.
 * Replaces the inline <script> blocks that previously lived in
 * sections/featured-collection.liquid and sections/related-featured.liquid
 * (and is extensible to any future section that opts in).
 *
 * Usage in markup:
 *   <ul class="... custom-slider" data-slider-init
 *       data-slides-desktop="4"
 *       data-slides-mobile="1.2"
 *       data-arrows="true"
 *       data-dots="false"
 *       data-infinite="true">
 *     ...
 *   </ul>
 *
 * Recognised attributes (all optional):
 *   data-slides-desktop (int,   default 4)
 *   data-slides-mobile  (float, default 1.2)
 *   data-arrows         ('true'|'false', default 'true')
 *   data-dots           ('true'|'false', default 'false')
 *   data-infinite       ('true'|'false', default 'true')
 *
 * Depends on: assets/slider-lite.js (defines window.SXSlider).
 * Both this file and slider-lite.js are loaded with `defer` from
 * layout/theme.liquid, so SXSlider is guaranteed to be defined by the
 * time the code below runs.
 *
 * Re-inits on shopify:section:load so the Shopify theme editor picks up
 * newly-rendered sliders when an editor edits a section.
 */
(function () {
  function initAll(root) {
    if (!window.SXSlider) return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-slider-init]:not([data-sx-init])').forEach(function (el) {
      new SXSlider(el, {
        slidesToShow: parseInt(el.dataset.slidesDesktop, 10) || 4,
        slidesToShowMobile: parseFloat(el.dataset.slidesMobile) || 1.2,
        arrows: el.dataset.arrows !== 'false',
        dots: el.dataset.dots === 'true',
        infinite: el.dataset.infinite !== 'false',
      });
    });
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    }, { once: true });
  }

  // Theme editor: re-init when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
